import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import useSessionTimer from '../../hooks/useSessionTimer';
import BackButton from '../BackButton';
import LoggedInMenu from './LoggedInMenu';

type LoggedInHeaderProps = {
    backLabel?: string;
    backUrl?: string;
    className?: string;
    email: string;
    sessionExpiration: number;
};

const LoggedInHeader: FC<LoggedInHeaderProps> = ({
    backLabel = '',
    backUrl = '/portal',
    className,
    email,
    sessionExpiration,
}) => {
    const {t} = useTranslation('Portal');
    const sessionStatus = useSessionTimer(sessionExpiration);

    return (
        <div className={clsx('flex mt-6 justify-between', className)}>
            <div>
                <BackButton
                    backUrl={backUrl}
                    label={backLabel || t('inbox.return')}
                />
            </div>
            <LoggedInMenu email={email} sessionStatus={sessionStatus} />
        </div>
    );
};

export default LoggedInHeader;
